/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    SponsoredRewardResponse,
    SponsoredRewardResponseFromJSON,
    SponsoredRewardResponseFromJSONTyped,
    SponsoredRewardResponseToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
    WinnerSummary,
    WinnerSummaryFromJSON,
    WinnerSummaryFromJSONTyped,
    WinnerSummaryToJSON,
} from './';

/**
 * Collection contains the user\'s reward stats/progress.
 * @export
 * @interface SponsoredGuildCompetitionWithWinners
 */
export interface SponsoredGuildCompetitionWithWinners {
    /**
     * Mongo id of the competition
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    id: string;
    /**
     * Brand name to display on guild page
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    sponsorBrandName: string;
    /**
     * Image to display on guild page.
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    promotionImage: string;
    /**
     * 
     * @type {Array<SponsoredRewardResponse>}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    rewards: Array<SponsoredRewardResponse>;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    runningMonth: number;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    runningYear: number;
    /**
     * 
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    brandUrl: string;
    /**
     * 
     * @type {Array<WinnerSummary>}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    winnerSummaries?: Array<WinnerSummary>;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    updatedAt: number;
}

export function SponsoredGuildCompetitionWithWinnersFromJSON(json: any): SponsoredGuildCompetitionWithWinners {
    return SponsoredGuildCompetitionWithWinnersFromJSONTyped(json, false);
}

export function SponsoredGuildCompetitionWithWinnersFromJSONTyped(json: any, ignoreDiscriminator: boolean): SponsoredGuildCompetitionWithWinners {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sponsorBrandName': json['sponsorBrandName'],
        'promotionImage': json['promotionImage'],
        'rewards': ((json['rewards'] as Array<any>).map(SponsoredRewardResponseFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'description': json['description'],
        'brandUrl': json['brandUrl'],
        'winnerSummaries': !exists(json, 'winnerSummaries') ? undefined : ((json['winnerSummaries'] as Array<any>).map(WinnerSummaryFromJSON)),
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function SponsoredGuildCompetitionWithWinnersToJSON(value?: SponsoredGuildCompetitionWithWinners | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sponsorBrandName': value.sponsorBrandName,
        'promotionImage': value.promotionImage,
        'rewards': ((value.rewards as Array<any>).map(SponsoredRewardResponseToJSON)),
        'runningMonth': value.runningMonth,
        'runningYear': value.runningYear,
        'description': value.description,
        'brandUrl': value.brandUrl,
        'winnerSummaries': value.winnerSummaries === undefined ? undefined : ((value.winnerSummaries as Array<any>).map(WinnerSummaryToJSON)),
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}


